import * as Types from 'src/actions/modal/open/Types';
import { Action } from 'redux';
import { ActionCreator } from 'react-redux';

export interface OpenModal extends Action {
  type: Types.OPEN_MODAL;
  payload: {modal: JSX.Element, className?: string};
}

export const openModal: ActionCreator<OpenModal> = (modal: JSX.Element, className?: string) => {
  return (
    {
      type: Types.OPEN_MODAL,
      payload: {modal: modal, className: className}
    }
  );
};


// WEBPACK FOOTER //
// ./src/actions/modal/open/Open.actions.tsx